const SECRET_PHRASE = "@keron*di5tribution";
const CLIENT_ROL_ID = 7;

const USER_TYPE_INTERNAL = "Interno";
const USER_TYPE_EXTERNAL_CLIENT = "Externo Cliente";
const USER_TYPE_EXTERNAL_PROVEEDOR = "Externo Proveedor";

export default { SECRET_PHRASE: SECRET_PHRASE, CLIENT_ROL_ID: CLIENT_ROL_ID, USER_TYPE_INTERNAL: USER_TYPE_INTERNAL, USER_TYPE_EXTERNAL_CLIENT: USER_TYPE_EXTERNAL_CLIENT, USER_TYPE_EXTERNAL_PROVEEDOR: USER_TYPE_EXTERNAL_PROVEEDOR };
